import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { category, template } from "../app/schema";

export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_ERROR = "GET_CATEGORIES_ERROR";

export const PATCH_CATEGORY = "PATCH_CATEGORY";
export const PATCH_CATEGORY_SUCCESS = "PATCH_CATEGORY_SUCCESS";
export const PATCH_CATEGORY_ERROR = "PATCH_CATEGORY_ERROR";

export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS";
export const DELETE_CATEGORY_ERROR = "DELETE_CATEGORY_ERROR";

export const SET_IS_REMOVE_CATEGORY_MODAL_VISIBLE =
  "SET_IS_REMOVE_CATEGORY_MODAL_VISIBLE";
export const SET_IS_EDIT_CATEGORY_MODAL_VISIBLE =
  "SET_IS_EDIT_CATEGORY_MODAL_VISIBLE";

// Requests
const getCategoriesGet = (fetch, apiHost, accessToken, meta) =>
  fetch(
    `${apiHost}/v1/categories?limit=${meta.limit}&offset=${meta.currentPage *
      meta.limit}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const patchCategory = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/categories/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteCategory = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/categories/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg:
          "Nie można usunąć danych szablonu, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

// Actions
export function getCategories(meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_CATEGORIES, GET_CATEGORIES_SUCCESS, GET_CATEGORIES_ERROR],
    payload: {
      promise: getCategoriesGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta
      )
        .then(data => {
          return normalize(data, { templates: arrayOf(template) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateCategory(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_CATEGORY, PATCH_CATEGORY_SUCCESS, PATCH_CATEGORY_ERROR],
    payload: {
      promise: patchCategory(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, template);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeCategory(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_CATEGORY, DELETE_CATEGORY_SUCCESS, DELETE_CATEGORY_ERROR],
    payload: {
      promise: deleteCategory(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function setIsRemoveCategoryModalVisible(value) {
  return {
    type: SET_IS_REMOVE_CATEGORY_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsEditCategoryModalVisible(value) {
  return {
    type: SET_IS_EDIT_CATEGORY_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/categories/actions.js